import { identityVerificationService } from '../api'

export async function requestAuthCheck (params, data) {
  const dob = data.birthdate
  const day = dob.getUTCDate().toString().padStart(2, '0')
  const month = (dob.getUTCMonth() + 1).toString().padStart(2, '0')
  const year = dob.getUTCFullYear()
  const dateOfBirth = [day, month, year].join('.')

  const streetAddress = data.streetName + ' ' + data.houseNumber
  const payload = {
    firstName: data.firstName,
    lastName: data.lastName,
    gender: data.gender === 'female' ? 'W' : 'M',
    dateOfBirth,
    streetAddress,
    postalCode: data.postalCode,
    city: data.city
  }

  try {
    const result = await identityVerificationService.create(payload, {
      query: {
        partnerPublicKey: params.publicKey,
        skip: params.skip
      }
    })

    return result
  } catch (err) {
    return {
      result: err.code === 404 ? 'invalid' : 'error'
    }
  }
}



// WEBPACK FOOTER //
// ./src/integrations/identityVerification.js